import React, { useState, useEffect } from 'react';

interface EmailModalProps {
    isOpen: boolean;
    onClose: () => void;
    email: string;
}

const EmailModal: React.FC<EmailModalProps> = ({ isOpen, onClose, email }) => {
    const [copied, setCopied] = useState(false);

    // Close on Escape key
    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [onClose]);

    if (!isOpen) return null;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(email);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-6">
            <div
                className="absolute inset-0 bg-black/40 transition-opacity animate-in fade-in duration-300"
                onClick={onClose}
            />

            <div className="relative bg-canvas border border-border rounded-3xl p-10 w-full max-w-sm shadow-2xl animate-in fade-in zoom-in-95 duration-300">
                {/* Close Button - Top Right */}
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 text-text-secondary hover:text-text-primary transition-colors p-2"
                    aria-label="Close"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>

                <div className="flex flex-col gap-10 items-center">
                    {/* Email - Centered */}
                    <p className="text-body text-text-primary tracking-tight text-center">
                        {email}
                    </p>

                    {/* Action Column - Stacked or Row? Row for desktop look */}
                    <div className="flex flex-col gap-4 w-full">
                        <button
                            onClick={handleCopy}
                            className="w-full text-lg text-text-primary whitespace-nowrap bg-transparent border border-text-primary px-6 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors"
                        >
                            {copied ? 'Copied' : 'Copy Address'}
                        </button>
                        <a
                            href={`mailto:${email}`}
                            className="w-full text-lg text-text-primary whitespace-nowrap bg-transparent border border-text-primary px-6 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors text-center"
                        >
                            Open Mail App
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailModal;
